import styled from 'styled-components';

export const Counter = styled.div`
  padding: 20px 0;
  font-size: 12pt;
  font-weight: 600;
`;

export default Counter;
